import type { Role } from '@/types/api';

/**
 * Qui peut atteindre quoi | Who may reach what.
 *
 * Ces ensembles sont le pendant exact des gardes de l'API — `requireStaff`,
 * `requireReporting`, `requireAdmin` — et sont la seule definition employee
 * par la navigation comme par les gardes de route.
 *
 * L'interface en portait jusqu'ici une deuxieme, qui rangeait l'auditeur parmi
 * l'encadrement alors que `requireStaff` l'en excluait. L'ecart ne se voyait
 * pas au type : il se voyait a l'usage, sous la forme d'une entree de menu qui
 * menait a « Une erreur est survenue ». Deux definitions de l'encadrement, ce
 * sont des portes ouvertes sur des pieces fermees.
 *
 * These mirror the API guards and are the single definition used by both the
 * navigation and the route guards.
 */

export const EVERYONE: Role[] = ['SUPER_ADMIN', 'ADMIN', 'INSTRUCTOR', 'AUDITOR', 'LEARNER'];

/** Ceux qui conduisent la formation et y ecrivent — l'API : `requireStaff`. */
export const STAFF: Role[] = ['SUPER_ADMIN', 'ADMIN', 'INSTRUCTOR'];

/** L'encadrement, auditeur compris, en lecture — l'API : `requireReporting`. */
export const OBSERVERS: Role[] = [...STAFF, 'AUDITOR'];

/** L'administration — l'API : `requireAdmin`. */
export const MANAGERS: Role[] = ['SUPER_ADMIN', 'ADMIN'];

/** Ce qui engage la plateforme entiere. */
export const SUPER: Role[] = ['SUPER_ADMIN'];
